// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-page {
  --support-ink: #1c2940;
  --support-muted: #728096;
  --support-blue: #3969d9;
  --support-border: #e7ebf1;
  min-height: 100vh;
  padding: 0 7.2%;
  color: var(--support-ink);
  background:
    radial-gradient(ellipse at 10% 38%, rgba(231, 239, 255, 0.78), transparent 40%),
    #f8faff;
  box-sizing: border-box;
}

.support-page *,
.support-page *::before,
.support-page *::after {
  box-sizing: inherit;
}

.support-header {
  height: 92px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1240px;
  margin: 0 auto;
}

.support-brand,
.support-back-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

.support-brand {
  gap: 10px;
  color: #25344e;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.8px;
}

.support-brand-mark {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #fff;
  background: linear-gradient(145deg, #5987f2, #3766d2);
  font-size: 23px;
  font-weight: 700;
  line-height: 1;
}

.support-brand-light {
  color: #6c7d98;
  font-weight: 400;
}

.support-back-link {
  gap: 8px;
  color: #63718a;
  font-size: 14px;
  transition: color 160ms ease;
}

.support-back-link:hover {
  color: var(--support-blue);
}

.support-back-link svg {
  font-size: 16px;
}

.support-layout {
  display: grid;
  grid-template-columns: minmax(260px, 0.83fr) minmax(470px, 1.17fr);
  gap: clamp(52px, 8vw, 122px);
  align-items: center;
  max-width: 1080px;
  min-height: calc(100vh - 156px);
  margin: 0 auto;
  padding: 35px 0 54px;
}

.support-intro {
  position: relative;
  align-self: center;
  padding-bottom: 18px;
}

.support-icon-wrap {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  margin-bottom: 30px;
  border: 1px solid #dce7ff;
  border-radius: 17px;
  color: var(--support-blue);
  background: #fff;
  box-shadow: 0 9px 22px rgba(45, 83, 153, 0.08);
  font-size: 24px;
}

.support-eyebrow,
.support-form-kicker {
  margin: 0 0 14px;
  color: var(--support-blue);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.55px;
}

.support-intro h1 {
  max-width: 390px;
  margin: 0;
  color: #1c2940;
  font-size: clamp(40px, 4.5vw, 55px);
  font-weight: 700;
  letter-spacing: -2.6px;
  line-height: 1.08;
}

.support-description {
  max-width: 390px;
  margin: 19px 0 32px;
  color: var(--support-muted);
  font-size: 16px;
  line-height: 1.7;
}

.support-note {
  display: flex;
  gap: 14px;
  max-width: 370px;
  padding: 18px 19px;
  border: 1px solid rgba(226, 233, 244, 0.88);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.72);
}

.support-note-icon {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: var(--support-blue);
  background: #edf3ff;
  font-size: 16px;
}

.support-note h2 {
  margin: 1px 0 5px;
  color: #293750;
  font-size: 14px;
  font-weight: 700;
}

.support-note p {
  margin: 0;
  color: var(--support-muted);
  font-size: 13px;
  line-height: 1.55;
}

.support-email-link {
  color: var(--support-blue);
  font-weight: 600;
  overflow-wrap: anywhere;
  text-decoration: none;
}

.support-email-link:hover {
  text-decoration: underline;
}

.support-email-link:focus-visible {
  border-radius: 2px;
  outline: 2px solid rgba(57, 105, 217, 0.4);
  outline-offset: 2px;
}

.support-decoration {
  position: absolute;
  z-index: -1;
  right: 4px;
  bottom: -56px;
  width: 180px;
  height: 80px;
  opacity: 0.55;
}

.support-decoration-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a9c0f6;
}

.support-decoration-dot-one {
  top: 10px;
  right: 38px;
}

.support-decoration-dot-two {
  top: 45px;
  right: 10px;
  width: 5px;
  height: 5px;
}

.support-decoration-line {
  position: absolute;
  top: 26px;
  right: 21px;
  width: 62px;
  height: 28px;
  border-top: 1px solid #b3c6ee;
  border-right: 1px solid #b3c6ee;
  border-radius: 0 16px 0 0;
  transform: rotate(18deg);
}

.support-form-card {
  width: 100%;
  padding: clamp(28px, 4vw, 43px);
  border: 1px solid rgba(231, 235, 241, 0.9);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(46, 69, 112, 0.09);
}

.support-form-heading {
  margin-bottom: 27px;
}

.support-form-kicker {
  margin-bottom: 9px;
  font-size: 10px;
}

.support-form-heading h2 {
  margin: 0;
  color: #202d44;
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.8px;
}

.support-form-heading > p:last-child {
  margin: 8px 0 0;
  color: #8390a3;
  font-size: 13px;
}

.support-form-heading > p:last-child span,
.support-field > span span {
  color: #dc5a64;
}

.support-form {
  display: flex;
  flex-direction: column;
  gap: 17px;
}

.support-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.support-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.support-field > span {
  color: #35435a;
  font-size: 13px;
  font-weight: 600;
}

.support-field input,
.support-field select,
.support-field textarea {
  width: 100%;
  min-height: 46px;
  padding: 12px 13px;
  border: 1px solid #e2e7ef;
  border-radius: 9px;
  outline: none;
  color: #2b3850;
  background: #fff;
  font: inherit;
  font-size: 13px;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.support-field input::placeholder,
.support-field textarea::placeholder {
  color: #a4adbb;
}

.support-field select:invalid {
  color: #a4adbb;
}

.support-field select option {
  color: #2b3850;
}

.support-field input:focus,
.support-field select:focus,
.support-field textarea:focus {
  border-color: #7b9ce8;
  box-shadow: 0 0 0 3px rgba(57, 105, 217, 0.11);
}

.support-field textarea {
  min-height: 116px;
  resize: vertical;
  line-height: 1.55;
}

.support-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 49px;
  margin-top: 2px;
  border: 0;
  border-radius: 9px;
  color: #fff;
  background: linear-gradient(100deg, #4777e6, #3866d1);
  box-shadow: 0 8px 16px rgba(57, 105, 217, 0.2);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease;
}

.support-submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(57, 105, 217, 0.27);
}

.support-submit:disabled {
  transform: none;
  box-shadow: none;
  cursor: wait;
  opacity: 0.72;
}

.support-form-error {
  margin: -4px 0 0;
  padding: 11px 13px;
  border: 1px solid #efc7c7;
  border-radius: 8px;
  color: #a53f3f;
  background: #fff5f5;
  font-size: 13px;
  line-height: 1.5;
}

.support-submit:focus-visible,
.support-back-link:focus-visible,
.support-brand:focus-visible {
  outline: 3px solid rgba(57, 105, 217, 0.35);
  outline-offset: 3px;
}

.support-submit span {
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
}

.support-form-disclaimer {
  margin: -6px 0 0;
  color: #8b96a7;
  font-size: 11px;
  text-align: center;
}

.support-preview-message {
  display: flex;
  gap: 14px;
  padding: 18px;
  border: 1px solid #cce8d7;
  border-radius: 12px;
  color: #27734a;
  background: #f2fbf5;
}

.support-preview-message > svg {
  flex: 0 0 21px;
  margin-top: 1px;
  font-size: 21px;
}

.support-preview-message h3 {
  margin: 0 0 5px;
  color: #275c3e;
  font-size: 15px;
}

.support-preview-message p {
  margin: 0;
  color: #557262;
  font-size: 13px;
  line-height: 1.55;
}

.support-footer {
  display: flex;
  justify-content: space-between;
  max-width: 1080px;
  margin: 0 auto;
  padding: 14px 0 22px;
  border-top: 1px solid rgba(223, 229, 239, 0.7);
  color: #8b96a7;
  font-size: 12px;
}

@media (max-width: 850px) {
  .support-page {
    padding: 0 5%;
  }

  .support-layout {
    grid-template-columns: minmax(220px, 0.8fr) minmax(390px, 1.2fr);
    gap: 35px;
  }

  .support-intro h1 {
    font-size: 42px;
  }
}

@media (max-width: 680px) {
  .support-header {
    height: 76px;
  }

  .support-layout {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 26px;
    min-height: auto;
    padding: 28px 0 36px;
  }

  .support-intro {
    padding-bottom: 0;
  }

  .support-icon-wrap {
    width: 46px;
    height: 46px;
    margin-bottom: 19px;
    border-radius: 14px;
  }

  .support-intro h1 {
    max-width: 100%;
    font-size: 40px;
  }

  .support-description {
    margin: 13px 0 18px;
    font-size: 15px;
  }

  .support-note {
    max-width: 100%;
  }

  .support-decoration {
    display: none;
  }

  .support-form-card {
    padding: 25px 21px;
    border-radius: 17px;
  }

  .support-form-heading h2 {
    font-size: 22px;
  }

  .support-footer {
    gap: 12px;
    padding-bottom: 18px;
  }
}

@media (max-width: 420px) {
  .support-back-link {
    display: none;
  }

  .support-brand {
    font-size: 19px;
  }

  .support-field-row {
    grid-template-columns: 1fr;
  }
}

.support-page {
  padding: 0;
  background:
    radial-gradient(ellipse at 8% 16%, rgba(231, 239, 255, 0.78), transparent 34%),
    #f8faff;
}

.support-header {
  height: 78px;
  padding: 0 7.2%;
  border-bottom: 1px solid rgba(223, 229, 239, 0.72);
  background: rgba(255, 255, 255, 0.78);
}

.support-header-inner,
.support-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}

.support-nav {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 26px;
  margin-left: auto;
  margin-right: 30px;
}

.support-nav-link {
  display: inline-flex;
  align-items: center;
  border-bottom: 2px solid transparent;
  color: #64776e;
  font-size: 14px;
  text-decoration: none;
  transition: border-color 160ms ease, color 160ms ease;
}

.support-nav-link:hover,
.support-nav-link-active {
  border-bottom-color: #13826a;
  color: #13826a;
}

.support-nav-link:focus-visible {
  outline: 3px solid rgba(17, 131, 106, 0.42);
  outline-offset: 3px;
}

.support-content {
  width: min(100% - 48px, 1080px);
  margin: 0 auto;
}

.support-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 66px 20px 58px;
  text-align: center;
}

.support-hero .support-icon-wrap {
  margin: 0 0 21px;
}

.support-hero .support-eyebrow {
  margin-bottom: 11px;
}

.support-hero h1 {
  margin: 0;
  color: #1c2940;
  font-size: clamp(38px, 5vw, 54px);
  font-weight: 700;
  letter-spacing: -2.4px;
  line-height: 1.12;
}

.support-hero .support-description {
  max-width: 560px;
  margin: 15px 0 0;
  font-size: 16px;
}

.support-faq-section {
  padding: 37px 0 68px;
}

.support-section-heading {
  margin-bottom: 27px;
  text-align: center;
}

.support-section-heading .support-eyebrow {
  margin-bottom: 9px;
}

.support-section-heading h2,
.support-contact-intro h2 {
  margin: 0;
  color: #202d44;
  font-size: clamp(26px, 3vw, 33px);
  font-weight: 700;
  letter-spacing: -1px;
}

.support-section-heading > p:last-child {
  margin: 10px 0 0;
  color: var(--support-muted);
  font-size: 14px;
}

.support-faq-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.support-faq-item {
  align-self: start;
  padding: 17px 19px;
  border: 1px solid #e7ebf1;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(46, 69, 112, 0.035);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.support-faq-item[open] {
  border-color: #d5e0f7;
  box-shadow: 0 9px 24px rgba(46, 69, 112, 0.07);
}

.support-faq-item summary {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 12px;
  align-items: center;
  list-style: none;
  cursor: pointer;
}

.support-faq-item summary::-webkit-details-marker {
  display: none;
}

.support-faq-category {
  grid-column: 1;
  color: var(--support-blue);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.9px;
  text-transform: uppercase;
}

.support-faq-question {
  grid-column: 1;
  color: #2d3a51;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
}

.support-faq-toggle {
  position: relative;
  grid-column: 2;
  grid-row: 1 / span 2;
  width: 24px;
  height: 24px;
  border: 1px solid #e5eaf2;
  border-radius: 50%;
  background: #f8faff;
}

.support-faq-toggle::before,
.support-faq-toggle::after {
  position: absolute;
  top: 11px;
  left: 7px;
  width: 8px;
  height: 1.5px;
  border-radius: 2px;
  background: #65748d;
  content: "";
}

.support-faq-toggle::after {
  transform: rotate(90deg);
  transition: transform 160ms ease;
}

.support-faq-item[open] .support-faq-toggle::after {
  transform: rotate(0);
}

.support-faq-item > p {
  margin: 13px 32px 0 0;
  padding-top: 12px;
  border-top: 1px solid #eef1f6;
  color: #728096;
  font-size: 13px;
  line-height: 1.65;
}

.support-contact-section {
  display: grid;
  grid-template-columns: minmax(240px, 0.8fr) minmax(0, 1.2fr);
  gap: clamp(32px, 6vw, 82px);
  align-items: start;
  padding: 54px clamp(22px, 5vw, 62px);
  border: 1px solid rgba(225, 232, 243, 0.9);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 52px rgba(46, 69, 112, 0.055);
}

.support-contact-intro {
  padding-top: 8px;
}

.support-contact-intro .support-eyebrow {
  margin-bottom: 10px;
}

.support-contact-intro h2 {
  font-size: clamp(25px, 3vw, 32px);
  line-height: 1.2;
}

.support-contact-intro > p:not(.support-eyebrow) {
  margin: 13px 0 23px;
  color: var(--support-muted);
  font-size: 15px;
  line-height: 1.65;
}

.support-note {
  max-width: 100%;
  padding: 15px;
  background: #f9fbff;
}

.support-note h3 {
  margin: 1px 0 5px;
  color: #293750;
  font-size: 14px;
  font-weight: 700;
}

.support-form-card {
  padding: 29px;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(46, 69, 112, 0.055);
}

.support-form-heading {
  margin-bottom: 22px;
}

.support-form-heading h3 {
  margin: 0;
  color: #202d44;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.6px;
}

.support-form-heading h3 + p {
  margin: 8px 0 0;
  color: #8390a3;
  font-size: 13px;
}

.support-preview-message h4 {
  margin: 0 0 5px;
  color: #275c3e;
  font-size: 15px;
}

.support-footer {
  margin-top: 72px;
  padding: 0 7.2%;
  border: 0;
  background: #fff;
}

.support-footer-inner {
  min-height: 76px;
  gap: 18px;
  border-top: 1px solid #edf0f5;
  color: #8b96a7;
  font-size: 12px;
}

.support-footer-brand {
  color: #35435a;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.support-footer-inner > a:last-child {
  color: #63718a;
  text-decoration: none;
}

.support-footer-inner > a:last-child:hover {
  color: var(--support-blue);
}

@media (max-width: 760px) {
  .support-contact-section {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 34px 25px;
  }

  .support-faq-list {
    grid-template-columns: 1fr;
  }

  .support-faq-section {
    padding: 22px 0 48px;
  }

  .support-footer {
    margin-top: 48px;
  }
}

@media (max-width: 560px) {
  .support-header {
    height: 70px;
    padding: 0 20px;
  }

  .support-header-inner {
    gap: 12px;
  }

  .support-back-link {
    display: none;
  }

  .support-nav {
    gap: 13px;
    margin-right: 0;
  }

  .support-nav-link {
    font-size: 12px;
  }

  .support-brand {
    gap: 8px;
    font-size: 17px;
    letter-spacing: -0.4px;
  }

  .support-brand-mark {
    width: 30px;
    height: 30px;
    border-radius: 9px;
    font-size: 18px;
  }

  .support-content {
    width: calc(100% - 36px);
  }

  .support-hero {
    padding: 48px 5px 35px;
  }

  .support-hero h1 {
    font-size: 39px;
    letter-spacing: -1.7px;
  }

  .support-hero .support-description {
    font-size: 15px;
  }

  .support-section-heading h2 {
    font-size: 26px;
  }

  .support-contact-section {
    padding: 27px 17px;
    border-radius: 16px;
  }

  .support-form-card {
    padding: 22px 17px;
  }

  .support-footer {
    margin-top: 38px;
    padding: 0 18px;
  }

  .support-footer-inner {
    flex-wrap: wrap;
    justify-content: center;
    min-height: 88px;
    gap: 8px 17px;
    padding: 16px 0;
    text-align: center;
  }

  .support-footer-inner > span {
    flex-basis: 100%;
    order: 1;
  }
}

.support-page {
  --support-ink: #17352d;
  --support-muted: #61766d;
  --support-blue: #10836b;
  --support-border: #cddbd2;
  background:
    radial-gradient(ellipse at 50% 24%, rgba(242, 248, 243, 0.95), transparent 48%),
    #f6faf6;
}

.support-header {
  border-bottom-color: rgba(198, 215, 203, 0.72);
  background: rgba(250, 252, 249, 0.86);
}

.support-brand,
.support-hero h1,
.support-section-heading h2,
.support-contact-intro h2,
.support-form-heading h3 {
  color: #137e68;
}

.support-brand-light {
  color: #638076;
}

.support-brand-mark {
  background: linear-gradient(145deg, #159579, #08725d);
}

.support-back-link,
.support-footer-inner > a:last-child {
  color: #596d64;
}

.support-back-link:hover,
.support-footer-inner > a:last-child:hover {
  color: #0c8068;
}

.support-hero {
  padding-top: 58px;
  padding-bottom: 46px;
}

.support-hero .support-icon-wrap {
  border-color: #c8ded1;
  color: #11836a;
  background: linear-gradient(155deg, #fff 8%, #e0eddf 100%);
  box-shadow: 0 10px 26px rgba(28, 101, 77, 0.09);
}

.support-eyebrow,
.support-form-kicker {
  color: #16816a;
}

.support-faq-section {
  padding-top: 30px;
}

.support-section-heading {
  margin-bottom: 23px;
}

.support-faq-list {
  gap: 14px;
}

.support-faq-item {
  padding: 19px 20px;
  border-color: #d5e0d8;
  border-radius: 14px;
  background: linear-gradient(155deg, #fff 6%, #f2f7f1 100%);
  box-shadow: 0 7px 20px rgba(39, 87, 63, 0.045);
}

.support-faq-item:hover,
.support-faq-item[open] {
  border-color: #a8cdb9;
  box-shadow: 0 10px 25px rgba(39, 87, 63, 0.09);
}

.support-faq-category,
.support-email-link {
  color: #117e66;
}

.support-faq-question {
  color: #273e35;
}

.support-faq-toggle {
  border-color: #d6e4da;
  background: #eff6ef;
}

.support-faq-toggle::before,
.support-faq-toggle::after {
  background: #317f67;
}

.support-faq-item > p {
  border-top-color: #dfe9e0;
  color: #61766d;
}

.support-contact-section {
  border-color: #cbdacf;
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(220, 235, 220, 0.82));
  box-shadow: 0 16px 42px rgba(39, 87, 63, 0.07);
}

.support-note {
  border-color: #d3e0d5;
  background: rgba(255, 255, 255, 0.74);
}

.support-note-icon {
  color: #137e68;
  background: #e3f0e5;
}

.support-note h3 {
  color: #274338;
}

.support-note p,
.support-description,
.support-section-heading > p:last-child,
.support-contact-intro > p:not(.support-eyebrow) {
  color: #64786f;
}

.support-form-card {
  border-color: #cbd8cf;
  border-radius: 17px;
  background: linear-gradient(160deg, #fff 0%, #f7faf6 100%);
  box-shadow: 0 14px 34px rgba(45, 79, 59, 0.1);
}

.support-form-heading h3 {
  letter-spacing: -0.5px;
}

.support-field > span {
  color: #30463c;
}

.support-field input,
.support-field select,
.support-field textarea {
  border-color: #ccd7cf;
  border-radius: 8px;
  color: #2e443a;
  background: rgba(255, 255, 255, 0.94);
}

.support-field input:focus,
.support-field select:focus,
.support-field textarea:focus {
  border-color: #42a488;
  box-shadow: 0 0 0 3px rgba(20, 133, 107, 0.12);
}

.support-submit {
  border-radius: 8px;
  background: linear-gradient(110deg, #88c9b0, #48a98b);
  box-shadow: 0 8px 16px rgba(27, 125, 97, 0.17);
}

.support-submit:hover {
  background: linear-gradient(110deg, #73bfa3, #329779);
  box-shadow: 0 10px 20px rgba(27, 125, 97, 0.23);
}

.support-submit:focus-visible,
.support-back-link:focus-visible,
.support-brand:focus-visible,
.support-email-link:focus-visible,
.support-faq-item summary:focus-visible {
  outline-color: rgba(17, 131, 106, 0.42);
}

.support-footer {
  background: rgba(255, 255, 255, 0.72);
}

.support-footer-inner {
  border-top-color: #d9e4db;
  color: #718078;
}

.support-footer-brand {
  color: #187c66;
}

@media (max-width: 760px) {
  .support-hero {
    padding-top: 45px;
    padding-bottom: 34px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ComponentsCss/Support/Support.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB;;WAES;EACT,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,qDAAqD;EACrD,8CAA8C;EAC9C,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gEAAgE;IAChE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;EACV;;WAES;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;;EAEE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB;;WAES;AACX;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,0DAA0D;EAC1D,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB;iFAC+E;EAC/E,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0DAA0D;EAC1D,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;AACvC;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":[".support-page {\n  --support-ink: #1c2940;\n  --support-muted: #728096;\n  --support-blue: #3969d9;\n  --support-border: #e7ebf1;\n  min-height: 100vh;\n  padding: 0 7.2%;\n  color: var(--support-ink);\n  background:\n    radial-gradient(ellipse at 10% 38%, rgba(231, 239, 255, 0.78), transparent 40%),\n    #f8faff;\n  box-sizing: border-box;\n}\n\n.support-page *,\n.support-page *::before,\n.support-page *::after {\n  box-sizing: inherit;\n}\n\n.support-header {\n  height: 92px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1240px;\n  margin: 0 auto;\n}\n\n.support-brand,\n.support-back-link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.support-brand {\n  gap: 10px;\n  color: #25344e;\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.8px;\n}\n\n.support-brand-mark {\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  border-radius: 11px;\n  color: #fff;\n  background: linear-gradient(145deg, #5987f2, #3766d2);\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.support-brand-light {\n  color: #6c7d98;\n  font-weight: 400;\n}\n\n.support-back-link {\n  gap: 8px;\n  color: #63718a;\n  font-size: 14px;\n  transition: color 160ms ease;\n}\n\n.support-back-link:hover {\n  color: var(--support-blue);\n}\n\n.support-back-link svg {\n  font-size: 16px;\n}\n\n.support-layout {\n  display: grid;\n  grid-template-columns: minmax(260px, 0.83fr) minmax(470px, 1.17fr);\n  gap: clamp(52px, 8vw, 122px);\n  align-items: center;\n  max-width: 1080px;\n  min-height: calc(100vh - 156px);\n  margin: 0 auto;\n  padding: 35px 0 54px;\n}\n\n.support-intro {\n  position: relative;\n  align-self: center;\n  padding-bottom: 18px;\n}\n\n.support-icon-wrap {\n  width: 54px;\n  height: 54px;\n  display: grid;\n  place-items: center;\n  margin-bottom: 30px;\n  border: 1px solid #dce7ff;\n  border-radius: 17px;\n  color: var(--support-blue);\n  background: #fff;\n  box-shadow: 0 9px 22px rgba(45, 83, 153, 0.08);\n  font-size: 24px;\n}\n\n.support-eyebrow,\n.support-form-kicker {\n  margin: 0 0 14px;\n  color: var(--support-blue);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.55px;\n}\n\n.support-intro h1 {\n  max-width: 390px;\n  margin: 0;\n  color: #1c2940;\n  font-size: clamp(40px, 4.5vw, 55px);\n  font-weight: 700;\n  letter-spacing: -2.6px;\n  line-height: 1.08;\n}\n\n.support-description {\n  max-width: 390px;\n  margin: 19px 0 32px;\n  color: var(--support-muted);\n  font-size: 16px;\n  line-height: 1.7;\n}\n\n.support-note {\n  display: flex;\n  gap: 14px;\n  max-width: 370px;\n  padding: 18px 19px;\n  border: 1px solid rgba(226, 233, 244, 0.88);\n  border-radius: 15px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.support-note-icon {\n  flex: 0 0 36px;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 11px;\n  color: var(--support-blue);\n  background: #edf3ff;\n  font-size: 16px;\n}\n\n.support-note h2 {\n  margin: 1px 0 5px;\n  color: #293750;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.support-note p {\n  margin: 0;\n  color: var(--support-muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.support-email-link {\n  color: var(--support-blue);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n  text-decoration: none;\n}\n\n.support-email-link:hover {\n  text-decoration: underline;\n}\n\n.support-email-link:focus-visible {\n  border-radius: 2px;\n  outline: 2px solid rgba(57, 105, 217, 0.4);\n  outline-offset: 2px;\n}\n\n.support-decoration {\n  position: absolute;\n  z-index: -1;\n  right: 4px;\n  bottom: -56px;\n  width: 180px;\n  height: 80px;\n  opacity: 0.55;\n}\n\n.support-decoration-dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #a9c0f6;\n}\n\n.support-decoration-dot-one {\n  top: 10px;\n  right: 38px;\n}\n\n.support-decoration-dot-two {\n  top: 45px;\n  right: 10px;\n  width: 5px;\n  height: 5px;\n}\n\n.support-decoration-line {\n  position: absolute;\n  top: 26px;\n  right: 21px;\n  width: 62px;\n  height: 28px;\n  border-top: 1px solid #b3c6ee;\n  border-right: 1px solid #b3c6ee;\n  border-radius: 0 16px 0 0;\n  transform: rotate(18deg);\n}\n\n.support-form-card {\n  width: 100%;\n  padding: clamp(28px, 4vw, 43px);\n  border: 1px solid rgba(231, 235, 241, 0.9);\n  border-radius: 22px;\n  background: #fff;\n  box-shadow: 0 24px 70px rgba(46, 69, 112, 0.09);\n}\n\n.support-form-heading {\n  margin-bottom: 27px;\n}\n\n.support-form-kicker {\n  margin-bottom: 9px;\n  font-size: 10px;\n}\n\n.support-form-heading h2 {\n  margin: 0;\n  color: #202d44;\n  font-size: 25px;\n  font-weight: 700;\n  letter-spacing: -0.8px;\n}\n\n.support-form-heading > p:last-child {\n  margin: 8px 0 0;\n  color: #8390a3;\n  font-size: 13px;\n}\n\n.support-form-heading > p:last-child span,\n.support-field > span span {\n  color: #dc5a64;\n}\n\n.support-form {\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n}\n\n.support-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.support-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.support-field > span {\n  color: #35435a;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.support-field input,\n.support-field select,\n.support-field textarea {\n  width: 100%;\n  min-height: 46px;\n  padding: 12px 13px;\n  border: 1px solid #e2e7ef;\n  border-radius: 9px;\n  outline: none;\n  color: #2b3850;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.support-field input::placeholder,\n.support-field textarea::placeholder {\n  color: #a4adbb;\n}\n\n.support-field select:invalid {\n  color: #a4adbb;\n}\n\n.support-field select option {\n  color: #2b3850;\n}\n\n.support-field input:focus,\n.support-field select:focus,\n.support-field textarea:focus {\n  border-color: #7b9ce8;\n  box-shadow: 0 0 0 3px rgba(57, 105, 217, 0.11);\n}\n\n.support-field textarea {\n  min-height: 116px;\n  resize: vertical;\n  line-height: 1.55;\n}\n\n.support-submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 49px;\n  margin-top: 2px;\n  border: 0;\n  border-radius: 9px;\n  color: #fff;\n  background: linear-gradient(100deg, #4777e6, #3866d1);\n  box-shadow: 0 8px 16px rgba(57, 105, 217, 0.2);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 160ms ease, box-shadow 160ms ease;\n}\n\n.support-submit:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 20px rgba(57, 105, 217, 0.27);\n}\n\n.support-submit:disabled {\n  transform: none;\n  box-shadow: none;\n  cursor: wait;\n  opacity: 0.72;\n}\n\n.support-form-error {\n  margin: -4px 0 0;\n  padding: 11px 13px;\n  border: 1px solid #efc7c7;\n  border-radius: 8px;\n  color: #a53f3f;\n  background: #fff5f5;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.support-submit:focus-visible,\n.support-back-link:focus-visible,\n.support-brand:focus-visible {\n  outline: 3px solid rgba(57, 105, 217, 0.35);\n  outline-offset: 3px;\n}\n\n.support-submit span {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.support-form-disclaimer {\n  margin: -6px 0 0;\n  color: #8b96a7;\n  font-size: 11px;\n  text-align: center;\n}\n\n.support-preview-message {\n  display: flex;\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid #cce8d7;\n  border-radius: 12px;\n  color: #27734a;\n  background: #f2fbf5;\n}\n\n.support-preview-message > svg {\n  flex: 0 0 21px;\n  margin-top: 1px;\n  font-size: 21px;\n}\n\n.support-preview-message h3 {\n  margin: 0 0 5px;\n  color: #275c3e;\n  font-size: 15px;\n}\n\n.support-preview-message p {\n  margin: 0;\n  color: #557262;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.support-footer {\n  display: flex;\n  justify-content: space-between;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 14px 0 22px;\n  border-top: 1px solid rgba(223, 229, 239, 0.7);\n  color: #8b96a7;\n  font-size: 12px;\n}\n\n@media (max-width: 850px) {\n  .support-page {\n    padding: 0 5%;\n  }\n\n  .support-layout {\n    grid-template-columns: minmax(220px, 0.8fr) minmax(390px, 1.2fr);\n    gap: 35px;\n  }\n\n  .support-intro h1 {\n    font-size: 42px;\n  }\n}\n\n@media (max-width: 680px) {\n  .support-header {\n    height: 76px;\n  }\n\n  .support-layout {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 26px;\n    min-height: auto;\n    padding: 28px 0 36px;\n  }\n\n  .support-intro {\n    padding-bottom: 0;\n  }\n\n  .support-icon-wrap {\n    width: 46px;\n    height: 46px;\n    margin-bottom: 19px;\n    border-radius: 14px;\n  }\n\n  .support-intro h1 {\n    max-width: 100%;\n    font-size: 40px;\n  }\n\n  .support-description {\n    margin: 13px 0 18px;\n    font-size: 15px;\n  }\n\n  .support-note {\n    max-width: 100%;\n  }\n\n  .support-decoration {\n    display: none;\n  }\n\n  .support-form-card {\n    padding: 25px 21px;\n    border-radius: 17px;\n  }\n\n  .support-form-heading h2 {\n    font-size: 22px;\n  }\n\n  .support-footer {\n    gap: 12px;\n    padding-bottom: 18px;\n  }\n}\n\n@media (max-width: 420px) {\n  .support-back-link {\n    display: none;\n  }\n\n  .support-brand {\n    font-size: 19px;\n  }\n\n  .support-field-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.support-page {\n  padding: 0;\n  background:\n    radial-gradient(ellipse at 8% 16%, rgba(231, 239, 255, 0.78), transparent 34%),\n    #f8faff;\n}\n\n.support-header {\n  height: 78px;\n  padding: 0 7.2%;\n  border-bottom: 1px solid rgba(223, 229, 239, 0.72);\n  background: rgba(255, 255, 255, 0.78);\n}\n\n.support-header-inner,\n.support-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.support-nav {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  gap: 26px;\n  margin-left: auto;\n  margin-right: 30px;\n}\n\n.support-nav-link {\n  display: inline-flex;\n  align-items: center;\n  border-bottom: 2px solid transparent;\n  color: #64776e;\n  font-size: 14px;\n  text-decoration: none;\n  transition: border-color 160ms ease, color 160ms ease;\n}\n\n.support-nav-link:hover,\n.support-nav-link-active {\n  border-bottom-color: #13826a;\n  color: #13826a;\n}\n\n.support-nav-link:focus-visible {\n  outline: 3px solid rgba(17, 131, 106, 0.42);\n  outline-offset: 3px;\n}\n\n.support-content {\n  width: min(100% - 48px, 1080px);\n  margin: 0 auto;\n}\n\n.support-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 66px 20px 58px;\n  text-align: center;\n}\n\n.support-hero .support-icon-wrap {\n  margin: 0 0 21px;\n}\n\n.support-hero .support-eyebrow {\n  margin-bottom: 11px;\n}\n\n.support-hero h1 {\n  margin: 0;\n  color: #1c2940;\n  font-size: clamp(38px, 5vw, 54px);\n  font-weight: 700;\n  letter-spacing: -2.4px;\n  line-height: 1.12;\n}\n\n.support-hero .support-description {\n  max-width: 560px;\n  margin: 15px 0 0;\n  font-size: 16px;\n}\n\n.support-faq-section {\n  padding: 37px 0 68px;\n}\n\n.support-section-heading {\n  margin-bottom: 27px;\n  text-align: center;\n}\n\n.support-section-heading .support-eyebrow {\n  margin-bottom: 9px;\n}\n\n.support-section-heading h2,\n.support-contact-intro h2 {\n  margin: 0;\n  color: #202d44;\n  font-size: clamp(26px, 3vw, 33px);\n  font-weight: 700;\n  letter-spacing: -1px;\n}\n\n.support-section-heading > p:last-child {\n  margin: 10px 0 0;\n  color: var(--support-muted);\n  font-size: 14px;\n}\n\n.support-faq-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.support-faq-item {\n  align-self: start;\n  padding: 17px 19px;\n  border: 1px solid #e7ebf1;\n  border-radius: 13px;\n  background: #fff;\n  box-shadow: 0 5px 18px rgba(46, 69, 112, 0.035);\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.support-faq-item[open] {\n  border-color: #d5e0f7;\n  box-shadow: 0 9px 24px rgba(46, 69, 112, 0.07);\n}\n\n.support-faq-item summary {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px 12px;\n  align-items: center;\n  list-style: none;\n  cursor: pointer;\n}\n\n.support-faq-item summary::-webkit-details-marker {\n  display: none;\n}\n\n.support-faq-category {\n  grid-column: 1;\n  color: var(--support-blue);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n}\n\n.support-faq-question {\n  grid-column: 1;\n  color: #2d3a51;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.support-faq-toggle {\n  position: relative;\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  width: 24px;\n  height: 24px;\n  border: 1px solid #e5eaf2;\n  border-radius: 50%;\n  background: #f8faff;\n}\n\n.support-faq-toggle::before,\n.support-faq-toggle::after {\n  position: absolute;\n  top: 11px;\n  left: 7px;\n  width: 8px;\n  height: 1.5px;\n  border-radius: 2px;\n  background: #65748d;\n  content: \"\";\n}\n\n.support-faq-toggle::after {\n  transform: rotate(90deg);\n  transition: transform 160ms ease;\n}\n\n.support-faq-item[open] .support-faq-toggle::after {\n  transform: rotate(0);\n}\n\n.support-faq-item > p {\n  margin: 13px 32px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid #eef1f6;\n  color: #728096;\n  font-size: 13px;\n  line-height: 1.65;\n}\n\n.support-contact-section {\n  display: grid;\n  grid-template-columns: minmax(240px, 0.8fr) minmax(0, 1.2fr);\n  gap: clamp(32px, 6vw, 82px);\n  align-items: start;\n  padding: 54px clamp(22px, 5vw, 62px);\n  border: 1px solid rgba(225, 232, 243, 0.9);\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.78);\n  box-shadow: 0 18px 52px rgba(46, 69, 112, 0.055);\n}\n\n.support-contact-intro {\n  padding-top: 8px;\n}\n\n.support-contact-intro .support-eyebrow {\n  margin-bottom: 10px;\n}\n\n.support-contact-intro h2 {\n  font-size: clamp(25px, 3vw, 32px);\n  line-height: 1.2;\n}\n\n.support-contact-intro > p:not(.support-eyebrow) {\n  margin: 13px 0 23px;\n  color: var(--support-muted);\n  font-size: 15px;\n  line-height: 1.65;\n}\n\n.support-note {\n  max-width: 100%;\n  padding: 15px;\n  background: #f9fbff;\n}\n\n.support-note h3 {\n  margin: 1px 0 5px;\n  color: #293750;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.support-form-card {\n  padding: 29px;\n  border-radius: 15px;\n  box-shadow: 0 8px 28px rgba(46, 69, 112, 0.055);\n}\n\n.support-form-heading {\n  margin-bottom: 22px;\n}\n\n.support-form-heading h3 {\n  margin: 0;\n  color: #202d44;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.6px;\n}\n\n.support-form-heading h3 + p {\n  margin: 8px 0 0;\n  color: #8390a3;\n  font-size: 13px;\n}\n\n.support-preview-message h4 {\n  margin: 0 0 5px;\n  color: #275c3e;\n  font-size: 15px;\n}\n\n.support-footer {\n  margin-top: 72px;\n  padding: 0 7.2%;\n  border: 0;\n  background: #fff;\n}\n\n.support-footer-inner {\n  min-height: 76px;\n  gap: 18px;\n  border-top: 1px solid #edf0f5;\n  color: #8b96a7;\n  font-size: 12px;\n}\n\n.support-footer-brand {\n  color: #35435a;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.support-footer-inner > a:last-child {\n  color: #63718a;\n  text-decoration: none;\n}\n\n.support-footer-inner > a:last-child:hover {\n  color: var(--support-blue);\n}\n\n@media (max-width: 760px) {\n  .support-contact-section {\n    grid-template-columns: 1fr;\n    gap: 24px;\n    padding: 34px 25px;\n  }\n\n  .support-faq-list {\n    grid-template-columns: 1fr;\n  }\n\n  .support-faq-section {\n    padding: 22px 0 48px;\n  }\n\n  .support-footer {\n    margin-top: 48px;\n  }\n}\n\n@media (max-width: 560px) {\n  .support-header {\n    height: 70px;\n    padding: 0 20px;\n  }\n\n  .support-header-inner {\n    gap: 12px;\n  }\n\n  .support-back-link {\n    display: none;\n  }\n\n  .support-nav {\n    gap: 13px;\n    margin-right: 0;\n  }\n\n  .support-nav-link {\n    font-size: 12px;\n  }\n\n  .support-brand {\n    gap: 8px;\n    font-size: 17px;\n    letter-spacing: -0.4px;\n  }\n\n  .support-brand-mark {\n    width: 30px;\n    height: 30px;\n    border-radius: 9px;\n    font-size: 18px;\n  }\n\n  .support-content {\n    width: calc(100% - 36px);\n  }\n\n  .support-hero {\n    padding: 48px 5px 35px;\n  }\n\n  .support-hero h1 {\n    font-size: 39px;\n    letter-spacing: -1.7px;\n  }\n\n  .support-hero .support-description {\n    font-size: 15px;\n  }\n\n  .support-section-heading h2 {\n    font-size: 26px;\n  }\n\n  .support-contact-section {\n    padding: 27px 17px;\n    border-radius: 16px;\n  }\n\n  .support-form-card {\n    padding: 22px 17px;\n  }\n\n  .support-footer {\n    margin-top: 38px;\n    padding: 0 18px;\n  }\n\n  .support-footer-inner {\n    flex-wrap: wrap;\n    justify-content: center;\n    min-height: 88px;\n    gap: 8px 17px;\n    padding: 16px 0;\n    text-align: center;\n  }\n\n  .support-footer-inner > span {\n    flex-basis: 100%;\n    order: 1;\n  }\n}\n\n.support-page {\n  --support-ink: #17352d;\n  --support-muted: #61766d;\n  --support-blue: #10836b;\n  --support-border: #cddbd2;\n  background:\n    radial-gradient(ellipse at 50% 24%, rgba(242, 248, 243, 0.95), transparent 48%),\n    #f6faf6;\n}\n\n.support-header {\n  border-bottom-color: rgba(198, 215, 203, 0.72);\n  background: rgba(250, 252, 249, 0.86);\n}\n\n.support-brand,\n.support-hero h1,\n.support-section-heading h2,\n.support-contact-intro h2,\n.support-form-heading h3 {\n  color: #137e68;\n}\n\n.support-brand-light {\n  color: #638076;\n}\n\n.support-brand-mark {\n  background: linear-gradient(145deg, #159579, #08725d);\n}\n\n.support-back-link,\n.support-footer-inner > a:last-child {\n  color: #596d64;\n}\n\n.support-back-link:hover,\n.support-footer-inner > a:last-child:hover {\n  color: #0c8068;\n}\n\n.support-hero {\n  padding-top: 58px;\n  padding-bottom: 46px;\n}\n\n.support-hero .support-icon-wrap {\n  border-color: #c8ded1;\n  color: #11836a;\n  background: linear-gradient(155deg, #fff 8%, #e0eddf 100%);\n  box-shadow: 0 10px 26px rgba(28, 101, 77, 0.09);\n}\n\n.support-eyebrow,\n.support-form-kicker {\n  color: #16816a;\n}\n\n.support-faq-section {\n  padding-top: 30px;\n}\n\n.support-section-heading {\n  margin-bottom: 23px;\n}\n\n.support-faq-list {\n  gap: 14px;\n}\n\n.support-faq-item {\n  padding: 19px 20px;\n  border-color: #d5e0d8;\n  border-radius: 14px;\n  background: linear-gradient(155deg, #fff 6%, #f2f7f1 100%);\n  box-shadow: 0 7px 20px rgba(39, 87, 63, 0.045);\n}\n\n.support-faq-item:hover,\n.support-faq-item[open] {\n  border-color: #a8cdb9;\n  box-shadow: 0 10px 25px rgba(39, 87, 63, 0.09);\n}\n\n.support-faq-category,\n.support-email-link {\n  color: #117e66;\n}\n\n.support-faq-question {\n  color: #273e35;\n}\n\n.support-faq-toggle {\n  border-color: #d6e4da;\n  background: #eff6ef;\n}\n\n.support-faq-toggle::before,\n.support-faq-toggle::after {\n  background: #317f67;\n}\n\n.support-faq-item > p {\n  border-top-color: #dfe9e0;\n  color: #61766d;\n}\n\n.support-contact-section {\n  border-color: #cbdacf;\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.96), rgba(220, 235, 220, 0.82));\n  box-shadow: 0 16px 42px rgba(39, 87, 63, 0.07);\n}\n\n.support-note {\n  border-color: #d3e0d5;\n  background: rgba(255, 255, 255, 0.74);\n}\n\n.support-note-icon {\n  color: #137e68;\n  background: #e3f0e5;\n}\n\n.support-note h3 {\n  color: #274338;\n}\n\n.support-note p,\n.support-description,\n.support-section-heading > p:last-child,\n.support-contact-intro > p:not(.support-eyebrow) {\n  color: #64786f;\n}\n\n.support-form-card {\n  border-color: #cbd8cf;\n  border-radius: 17px;\n  background: linear-gradient(160deg, #fff 0%, #f7faf6 100%);\n  box-shadow: 0 14px 34px rgba(45, 79, 59, 0.1);\n}\n\n.support-form-heading h3 {\n  letter-spacing: -0.5px;\n}\n\n.support-field > span {\n  color: #30463c;\n}\n\n.support-field input,\n.support-field select,\n.support-field textarea {\n  border-color: #ccd7cf;\n  border-radius: 8px;\n  color: #2e443a;\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.support-field input:focus,\n.support-field select:focus,\n.support-field textarea:focus {\n  border-color: #42a488;\n  box-shadow: 0 0 0 3px rgba(20, 133, 107, 0.12);\n}\n\n.support-submit {\n  border-radius: 8px;\n  background: linear-gradient(110deg, #88c9b0, #48a98b);\n  box-shadow: 0 8px 16px rgba(27, 125, 97, 0.17);\n}\n\n.support-submit:hover {\n  background: linear-gradient(110deg, #73bfa3, #329779);\n  box-shadow: 0 10px 20px rgba(27, 125, 97, 0.23);\n}\n\n.support-submit:focus-visible,\n.support-back-link:focus-visible,\n.support-brand:focus-visible,\n.support-email-link:focus-visible,\n.support-faq-item summary:focus-visible {\n  outline-color: rgba(17, 131, 106, 0.42);\n}\n\n.support-footer {\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.support-footer-inner {\n  border-top-color: #d9e4db;\n  color: #718078;\n}\n\n.support-footer-brand {\n  color: #187c66;\n}\n\n@media (max-width: 760px) {\n  .support-hero {\n    padding-top: 45px;\n    padding-bottom: 34px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
